import { render, staticRenderFns } from "./notesModal.vue?vue&type=template&id=5bccef00&scoped=true&"
import script from "./notesModal.vue?vue&type=script&lang=js&"
export * from "./notesModal.vue?vue&type=script&lang=js&"
import style0 from "./notesModal.vue?vue&type=style&index=0&id=5bccef00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccef00",
  null
  
)

export default component.exports